import Icon from "@mdi/react";
import { mdiChevronRight } from "@mdi/js";

import type { ExibirMonitorTaskResponse } from "../../model/exibirMonitorTaskResponse";
import ListCard from "../ListCard";

type TarefasCardPropsContent = {
	data: ExibirMonitorTaskResponse;
	skeleton?: never;
	onClick?: () => void;
};

type TarefasCardPropsSkeleton = {
	data?: never;
	skeleton: true;
	onClick?: never;
};

type TarefasCardProps = TarefasCardPropsContent | TarefasCardPropsSkeleton;

export default function TarefasCard(props: TarefasCardProps) {
	function handleClick() {
		if (!props.skeleton && props.onClick) {
			props.onClick();
		}
	}

	let skeletonButton = "";
	if (props.skeleton) {
		skeletonButton = "skeleton skeleton-button";
	}

	const statusClass = props.data?.sucesso ? "text-success" : "text-danger";

	return (
		<ListCard onClick={handleClick}>
			<ListCard.Content>
				<ListCard.Item>
					<ListCard.Title skeleton={props.skeleton}>ID</ListCard.Title>
					<ListCard.Text skeleton={props.skeleton}>{props.data?.id ?? "..."}</ListCard.Text>
				</ListCard.Item>
				<ListCard.Item>
					<ListCard.Title skeleton={props.skeleton}>Latência</ListCard.Title>
					<ListCard.Text skeleton={props.skeleton}>{props.data?.latencia ?? "..."}</ListCard.Text>
				</ListCard.Item>
				<ListCard.Item>
					<ListCard.Title skeleton={props.skeleton}>Status</ListCard.Title>
					<ListCard.Text skeleton={props.skeleton}>
						<span className={statusClass}>{props.data?.statusResponse ?? "..."}</span>
					</ListCard.Text>
				</ListCard.Item>
				<ListCard.Item>
					<ListCard.Title skeleton={props.skeleton}>Sucesso</ListCard.Title>
					<ListCard.Text skeleton={props.skeleton}>
						<span className={statusClass}>{props.data?.sucesso !== undefined ? (props.data.sucesso ? "Sim" : "Não") : "..."}</span>
					</ListCard.Text>
				</ListCard.Item>
				<ListCard.Item>
					<ListCard.Title skeleton={props.skeleton}>Data Hora Início</ListCard.Title>
					<ListCard.Text skeleton={props.skeleton}>{props.data?.dataInicio ?? "..."}</ListCard.Text>
				</ListCard.Item>
				<ListCard.Item>
					<ListCard.Title skeleton={props.skeleton}>Data Hora Fim</ListCard.Title>
					<ListCard.Text skeleton={props.skeleton}>{props.data?.dataFim ?? "..."}</ListCard.Text>
				</ListCard.Item>
			</ListCard.Content>
			<ListCard.Action>
				<Icon path={mdiChevronRight} size={1} className={`text-muted m-2 ${skeletonButton}`} />
			</ListCard.Action>
		</ListCard>
	);
}
